function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import taxonomy from './taxonomy.js';
import { arrayEntry, internationalizedArraySanityFile, internationalizedArrayString, internationalizedArrayText, sanityReference } from '../fragments/index.js';
import researchGroup from './researchGroup.js';
import researchPlatform from './researchPlatform.js';
import documentSlug from '../fragments/documentSlug.js';
var schema = defineDocument('job', {
    slug: _object_spread({
        title: 'Slug'
    }, documentSlug.factory()),
    title: {
        title: 'Title',
        type: 'internationalizedArrayString'
    },
    description: {
        title: 'Description',
        type: 'internationalizedArrayText'
    },
    pdf: {
        title: 'PDF',
        type: 'internationalizedArraySanityFile'
    },
    datetime: {
        title: 'Datetime',
        type: 'datetime'
    },
    location: {
        title: 'Location',
        type: 'string'
    },
    taxonomies: {
        title: 'Taxonomies',
        description: 'Supports job type',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type in $types',
                    filterParams: {
                        types: [
                            TaxonomyType.JOB_TYPE
                        ]
                    }
                }
            }
        ]
    },
    linkedResearchContent: {
        title: 'Research groups and platforms',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'researchGroup'
                    },
                    {
                        type: 'researchPlatform'
                    }
                ]
            }
        ]
    }
}, [
    taxonomy.schema.taxonomy,
    researchGroup.schema.researchGroup,
    researchPlatform.schema.researchPlatform,
    {},
    {},
    {}
]);
var validator = z.object({
    slug: documentSlug.validator,
    title: internationalizedArrayString.validator,
    description: internationalizedArrayText.validator,
    pdf: internationalizedArraySanityFile.validator,
    date: z.string(),
    location: z.string(),
    taxonomies: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    linkedResearchContent: z.array(sanityReference.validator.merge(arrayEntry.validator))
}).partial();
schema.job;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=job.js.map